import { getCurrentYear } from "shared/topchef.utils";

const Footer = () => {

  return (
    <footer id="footer" data-testid="footer" className="d-flex justify-content-between align-items-center py-3 px-5 border-top" style={{background: 'white', position: 'absolute', bottom: 0, right: 0, width: 'calc(100% - 250px)'}}>
      <span id="footer_credits">© {getCurrentYear()} EventLink</span>
      <div id="footer_links">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="https://loc-hall.fr/prise-en-main-eventlink" target="_blank" rel="noreferrer" className="me-3 text-decoration-none">Aide</a>
        <a href="https://loc-hall.fr/conditions-de-referencement-prestataires/" target="_blank" rel="noreferrer" className="me-3 text-decoration-none">Conditions Générales</a>
        <a href="https://loc-hall.fr/charte-de-bonne-conduite-eventlink/" target="_blank" rel="noreferrer" className="me-3 text-decoration-none">Charte</a>
        <a href="mailto:eventlink@lochall.com" className="text-decoration-none">Contact support</a>
      </div>
    </footer>
  );

}

export default Footer;
